import {QrCodeType} from "./getQrCodes";
import {basePostRequest} from "../base/basePostRequest";

const postQrCode = async (id_project: number) =>
  basePostRequest<QrCodeType>(`/qr_code/`, {id_project});

export default postQrCode;
